import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

import {
  CONVERSATION_FETCH_REQUEST,
  CONVERSATION_FETCH_FAILURE,
  CONVERSATION_FETCH_SUCCESS,
  CONVERSATION_CREATE_MESSAGE_REQUEST,
  CONVERSATION_CREATE_MESSAGE_FAILURE,
  CONVERSATION_CREATE_MESSAGE_SUCCESS,
  CONVERSATION_MESSAGE_RECIEVED,
} from "./constants";

type FetchConversationArgs = {
  topicType: string;
  topicId: number;
  startAt?: Date;
};

export const fetchConversation: AsyncSagaAction<FetchConversationArgs> =
  createAsyncSaga(
    CONVERSATION_FETCH_REQUEST,
    CONVERSATION_FETCH_SUCCESS,
    CONVERSATION_FETCH_FAILURE,
    ({ topicType, topicId }: FetchConversationArgs) =>
      `conversation/${topicType}/${topicId}/fetch`,
    ({ topicType, topicId, startAt }: FetchConversationArgs) =>
      ApiService.listConversations({
        contentTypeModel: topicType,
        objectId: topicId,
        startAt: startAt?.toISOString && startAt.toISOString(),
      }),
    {
      loadedAtQueryParam: "startAt",
    }
  );

type CreateConversationMessageArgs = FetchConversationArgs & {
  body: string;
};

export const createConversationMessage: AsyncSagaAction<CreateConversationMessageArgs> =
  createAsyncSaga(
    CONVERSATION_CREATE_MESSAGE_REQUEST,
    CONVERSATION_CREATE_MESSAGE_SUCCESS,
    CONVERSATION_CREATE_MESSAGE_FAILURE,
    ({ topicType, topicId }: CreateConversationMessageArgs) =>
      `conversation/${topicType}/${topicId}/createMessage`,
    ({ topicType, topicId, body }: CreateConversationMessageArgs) =>
      ApiService.createPwMessage({
        requestBody: {
          body,
          content_type__model: topicType,
          object_id: topicId,
        },
      })
  );

export const conversationMessageRecieved = (
  topicType: string,
  topicId: number,
  message: any
) => ({
  type: CONVERSATION_MESSAGE_RECIEVED,
  args: { topicType, topicId },
  payload: { response: message },
});
